import {
  CognitoUserPool,
  CognitoUser,
  ICognitoUserData,
  AuthenticationDetails,
} from "amazon-cognito-identity-js";

export const getUserPool = (): CognitoUserPool => {
  const userPoolId: string = process.env.REACT_APP_AWS_USER_POOL_ID || "";
  const clientId: string = process.env.REACT_APP_AWS_COGNITO_CLIENT_ID || "";

  if (!userPoolId || !clientId) {
    throw new Error("UserPoolId または ClientId が設定されていません。");
  }

  return new CognitoUserPool({
    UserPoolId: userPoolId,
    ClientId: clientId,
  });
};

export const getUserData = (username: string): ICognitoUserData => {
  const userPool: CognitoUserPool = getUserPool();
  return {
    Username: username,
    Pool: userPool,
  };
};

export const getCognitoUser = (username: string): CognitoUser => {
  const userData: ICognitoUserData = getUserData(username);
  return new CognitoUser(userData);
};

export const getAuthDetails = (username: string, password: string) => {
  return new AuthenticationDetails({
    Username: username,
    Password: password,
  });
};
